import { gsap, TweenMax } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

const Anim = () => {

    // animation mousemove
    const tl      = gsap.timeline({ duration : 20 });
    const wrapper = document.querySelectorAll('[data-mousemove]');

    wrapper.forEach((item) => {
        item.addEventListener('mousemove', (e) => {
            if (window.matchMedia('(min-width: 1081px)').matches) {
                const elements = item.querySelectorAll('[data-mousemove-animate]');

                gsap.utils.toArray(elements).forEach((layer) => {
                    const { depth } = layer.dataset;
                    const relX    = e.pageX - item.offsetLeft;
                    const relY    = e.pageY - item.offsetTop;

                    TweenMax.to(layer, 1, {
                        x : (relX - item.offsetWidth / 2) / item.offsetWidth * depth,
                        y : (relY - item.offsetHeight / 2) / item.offsetHeight * depth,
                    });
                });
            }
        });
    });



    // animate block
    let itemAnimate = document.querySelectorAll('[data-scroll-animate]');

    itemAnimate.forEach(item => {
        let anim = JSON.parse(item.getAttribute('data-scroll-animate'));

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                toggleActions: 'restart none none reset',
            }
        })

        tl.from(item, anim.duration, {
            x: anim.x,
            y: anim.y,
            opacity: anim.opacity,
            ease: "none",
            delay: anim.delay,
        })
    })




};


export default Anim;
